import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import ItemAddon from "./ItemAddon";
import ItemTaxes from "./ItemTaxes";
import ItemVariant from "./ItemVariant";

function ItemAdditionalInfo({
  variants,
  setVariants,
  deletedVariants,
  setDeletedVariants,
  attributesKeyValue,
  selectedAttributes,
  setSelectedAttributes,
  isItemWithVariant,
  addons,
  setAddons,
  deletedAddons,
  setDeletedAddons,
  taxes,
  setTaxes,
}) {
  const [tab, setTab] = useState(0);

  const handleTabChange = (e, newValue) => setTab(newValue);

  return (
    <Box>
      {/* Tabs */}
      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Variants" />
        <Tab label="Addons" />
        <Tab label="Tax / GST" />
      </Tabs>

      {tab === 0 && (
        <Box sx={{ mt: 3 }}>
          <ItemVariant
            variants={variants}
            setVariants={setVariants}
            deletedVariants={deletedVariants}
            setDeletedVariants={setDeletedVariants}
            attributesKeyValue={attributesKeyValue}
            selectedAttributes={selectedAttributes}
            setSelectedAttributes={setSelectedAttributes}
            isItemWithVariant={isItemWithVariant}
          />
        </Box>
      )}

      {tab === 1 && (
        <Box sx={{ mt: 3 }}>
          <ItemAddon
            addons={addons}
            setAddons={setAddons}
            deletedAddons={deletedAddons}
            setDeletedAddons={setDeletedAddons}
          />
        </Box>
      )}

      {tab === 2 && (
        <Box sx={{ mt: 3 }}>
          <ItemTaxes taxes={taxes} setTaxes={setTaxes} />
        </Box>
      )}
    </Box>
  );
}

export default ItemAdditionalInfo;
